import React from "react";
import "leaflet-geotiff-2";
import "leaflet-geotiff-2/dist/leaflet-geotiff-plotty";
import { ExtraGeotiffLayer } from "./ExtraGeotiffLayer";
import geoblaze from "geoblaze";
import * as plotty from "leaflet-geotiff-2/node_modules/plotty";
import { palettes } from "../../../common/VisualizationPresets/colorPalettes";
import { getDownloadLink } from "../../../api/storageApi";
import { getExtraLegendDataProps } from "../../../redux/actions/legendActions";
import { connect } from "react-redux";

class ExtraTopography extends React.Component {
  async loadExtraTopographies() {
    if (!this.props.loadedProjectFiles || this.props.loadedProjectFiles.length === 0) {
      this.props.getExtraLegendDataProps([]);
      return;
    }

    let extraTopographies = this.props.loadedProjectFiles.filter((x) => {
      return x.type === "image/tiff";
    });
    
    if (extraTopographies.length !== 0) {
      const extraTopo = [];
      // Preserve existing checked state from Redux
      const existingExtraTopo = this.props.extraTopo || [];

      for (let index = 0; index < extraTopographies.length; index++) {
        const file = extraTopographies[index];
        // Check if this file already exists in the state (by name or path)
        const existingTopo = existingExtraTopo.find(
          (x) => x.name === file.name || (file.path && x.url && x.url.includes(file.path.split('/').pop()))
        );
        
        // If it exists and has a valid url, preserve its checked state
        if (existingTopo && existingTopo.url) {
          // Re-fetch the download link in case it expired, but preserve checked state
          try {
            const extraTopoUrl = await getDownloadLink(file.path);
            extraTopo.push({
              name: file.name,
              url: extraTopoUrl,
              max: existingTopo.max,
              min: existingTopo.min,
              checked: existingTopo.checked, // Preserve the checked state
            });
          } catch (error) {
            console.warn(`Failed to get download link for ${file.name}:`, error);
            // Fallback: use existing url if available
            if (existingTopo.url) {
              extraTopo.push({
                name: file.name,
                url: existingTopo.url,
                max: existingTopo.max,
                min: existingTopo.min,
                checked: existingTopo.checked,
              });
            }
          }
        } else {
          // New file - load it and set checked to false
          const extraTopoUrl = await getDownloadLink(file.path);
          const extraTopographyRaster = await geoblaze.load(extraTopoUrl);

          extraTopo.push({
            name: file.name,
            url: extraTopoUrl,
            max: ~~geoblaze.max(extraTopographyRaster)[0] + 1,
            min: ~~geoblaze.min(extraTopographyRaster)[0] - 1,
            checked: false,
          });
        }
      }

      const elevationPallete = palettes.colors.elevation[`greysRev`];
      const nameOfElevationStyle = this.props.inputElevationPalette;
      plotty.addColorScale(
        `greysRev`,
        elevationPallete,
        [0, 0.12, 0.24, 0.36, 0.48, 0.6, 0.72, 0.84, 1]
      );

      this.props.getExtraLegendDataProps(extraTopo);
    } else if (extraTopographies.length === 0) {
      this.props.getExtraLegendDataProps([]);
    }
  }

  async componentDidMount() {
    await this.loadExtraTopographies();
  }

  async componentDidUpdate(prevProps) {
    // Reload if files changed
    if (
      prevProps.loadedProjectFiles !== this.props.loadedProjectFiles ||
      (prevProps.loadedProjectFiles?.length !== this.props.loadedProjectFiles?.length)
    ) {
      await this.loadExtraTopographies();
    }
  }

  render() {
    return (
      <>
        {this.props.extraTopo.length !== 0 &&
          this.props.extraTopo.map((x) => {
            if (x.checked) {
              return (
                <ExtraGeotiffLayer
                  topographyUrl={x.url}
                  colorName={"greysRev"}
                  displayMin={x.min}
                  displayMax={x.max}
                />
              );
            }
            return <></>;
          })}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loadedProjectFiles: state.projects.loadedProject.files,
    inputElevationPalette:
      state.userSettings?.settings?.visualizationPresets
        ?.inputElevationPalette || palettes.defaults.elevation,
    extraTopo: state.legend.extraTopo,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getExtraLegendDataProps: (payload) =>
      dispatch(getExtraLegendDataProps(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ExtraTopography);
